import Constants from './constants';

export default {
  Constants,
};
